(function () {
  var MAX_SLICK_READY_ATTEMPTS = 20;
  var SLICK_READY_DELAY = 100;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function clearFallbackState($mainImageSlider) {
    $mainImageSlider
      .removeClass('is-product-gallery-fallback')
      .find('.image-link')
      .removeClass('is-active');
  }

  function initProductGallery($, gallery) {
    var $gallery = $(gallery);
    var $thumbnailSlider = $gallery.find('.thumbnails-slider');
    var $mainImageSlider = $gallery.find('.main-image-slider');
    var $mainSlides = $mainImageSlider.find('.image-link');
    var mediaCount = $mainImageSlider.find('.image-link').length;

    if (!mediaCount || !$thumbnailSlider.length || !$mainImageSlider.length) return;

    if (!$gallery.find('.product-gallery-counter').length) {
      $gallery.append('<div class="product-gallery-counter" aria-live="polite"></div>');
    }

    function getCurrentIndex() {
      var index = Number($thumbnailSlider.find('.thumbnail-button[aria-current="true"]').first().data('media-index'));

      return Number.isNaN(index) ? 0 : index;
    }

    function setActiveThumbnail(index) {
      $thumbnailSlider.find('.thumbnail-button').removeAttr('aria-current');
      $thumbnailSlider
        .find('.thumbnail-button[data-media-index="' + index + '"]')
        .attr('aria-current', true);

      if ($thumbnailSlider.hasClass('slick-initialized')) {
        $thumbnailSlider.slick('slickGoTo', index);
      }
    }

    function setGalleryCounter(index) {
      var $counter = $gallery.find('.product-gallery-counter');

      if (!$counter.length) return;

      $counter.text(index + 1 + ' / ' + mediaCount);
    }

    function setFallbackSlide(index) {
      $mainImageSlider.addClass('is-product-gallery-fallback');
      $mainSlides.each(function (slideIndex) {
        this.classList.toggle('is-active', slideIndex === index);
      });
    }

    function bindThumbnailWheel() {
      if (gallery.dataset.productGalleryWheelBound === 'true') return;

      gallery.dataset.productGalleryWheelBound = 'true';
      $thumbnailSlider[0].addEventListener(
        'wheel',
        function (event) {
          if (!window.matchMedia('(min-width: 992px)').matches) return;
          if (!$thumbnailSlider.hasClass('slick-initialized')) return;

          var slick = $thumbnailSlider.slick('getSlick');
          var slidesToShow = slick.options.slidesToShow || 1;
          var lastVisibleStart = Math.max(slick.slideCount - slidesToShow, 0);
          var direction = event.deltaY > 0 ? 1 : -1;
          var canScrollNext = direction > 0 && slick.currentSlide < lastVisibleStart;
          var canScrollPrevious = direction < 0 && slick.currentSlide > 0;

          if (!canScrollNext && !canScrollPrevious) return;

          event.preventDefault();
          $thumbnailSlider.slick(direction > 0 ? 'slickNext' : 'slickPrev');
        },
        { passive: false }
      );
    }

    var currentIndex = getCurrentIndex();

    setActiveThumbnail(currentIndex);
    setGalleryCounter(currentIndex);

    if (gallery.dataset.productGalleryEventsBound !== 'true') {
      gallery.dataset.productGalleryEventsBound = 'true';

      $thumbnailSlider.on('click.productGallery', '.thumbnail-button', function () {
        var index = Number($(this).data('media-index'));
        if (Number.isNaN(index)) return;

        setActiveThumbnail(index);
        setGalleryCounter(index);

        if ($mainImageSlider.hasClass('slick-initialized')) {
          $mainImageSlider.slick('slickGoTo', index);
        } else {
          setFallbackSlide(index);
        }
      });
    }

    if (gallery.dataset.productGalleryInitialized === 'true') return;

    if (mediaCount <= 1 || !$.fn.slick) return;

    clearFallbackState($mainImageSlider);

    $mainImageSlider.on('beforeChange.productGallery', function (event, slider, currentSlide, nextSlide) {
      setActiveThumbnail(nextSlide);
      setGalleryCounter(nextSlide);
    });

    if (!$thumbnailSlider.hasClass('slick-initialized')) {
      $thumbnailSlider.slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: currentIndex,
        infinite: false,
        arrows: false,
        instructionsText: '',
        regionLabel: 'thumbnails carousel',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              vertical: false,
              verticalSwiping: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              vertical: false,
              verticalSwiping: false,
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
        ],
      });
    }

    bindThumbnailWheel();

    if (!$mainImageSlider.hasClass('slick-initialized')) {
      $mainImageSlider.slick({
        slidesToShow: 1,
        initialSlide: currentIndex,
        arrows: false,
        draggable: true,
        instructionsText: '',
        slidesToScroll: 1,
        swipe: true,
        touchMove: true,
        autoplay: false,
        infinite: false,
        regionLabel: 'main image carousel',
      });
    }

    gallery.dataset.productGalleryInitialized = 'true';
  }

  function initGalleries(attempt) {
    if (!window.jQuery) {
      if (attempt >= MAX_SLICK_READY_ATTEMPTS) return;

      window.setTimeout(function () {
        initGalleries(attempt + 1);
      }, SLICK_READY_DELAY);

      return;
    }

    window.jQuery('.product-image-carousels').each(function () {
      if (this.dataset.productGalleryInitialized === 'true') return;

      initProductGallery(window.jQuery, this);
    });

    if (window.jQuery.fn && window.jQuery.fn.slick) return;
    if (attempt >= MAX_SLICK_READY_ATTEMPTS) return;

    window.setTimeout(function () {
      initGalleries(attempt + 1);
    }, SLICK_READY_DELAY);
  }

  onReady(function () {
    initGalleries(0);
  });
})();
